import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    background: {
      default: '#001523', // Main page background
      paper: '#001523',   // Surfaces like Cards, Paper, etc.
    },
    text: {
      primary: '#ffffff',
      secondary: '#cccccc',
    },
    // You can still define primary, secondary, etc.
    primary: {
      main: '#1abc9c',
    },
    secondary: {
      main: '#A48FF0', /* approximate pastel purple */
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    // Adjust headings if you want bigger/smaller text
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      letterSpacing: '0.05em',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
  },
  shape: {
    borderRadius: '10px',
  },
  customRounding: {
    contentFrame: '24px',
  },
  // New custom border weight to be used globally
  customBorderWeight: '1px',
  // New default rounding for images
  customImageRounding: '10px',
  // NEW custom property for input text color
  customInputText: 'black',
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#1c1c1c',
        },
      },
    },
    // ...override other components as needed
  },
});

export default theme;